/* eslint-disable func-style */
import React from 'react';
import {
  MonitoringContextController,
  useMonitoringContext,
} from './MonitorContext.jsx';
import { Message } from 'semantic-ui-react';
import MonitorView from './MonitorView.jsx';
import Footer from './Footer.jsx';
import useTimeout from '../hooks/useTimeout.jsx';

const MESSAGE_DURATION = 60000; // milliseconds

export default function EdgeMonitor({
  currentlyExpired,
  currentlyMonitoring,
  nodesToMonitor,
  currentExpiresAt,
  defaultExpiresIn,
  triggerMonitoringUrl,
}) {
  return (
    <MonitoringContextController
      defaultExpiresIn={defaultExpiresIn}
      expiresAt={currentExpiresAt}
      isExpired={currentlyExpired}
      isMonitoring={currentlyMonitoring}
      nodesToMonitor={nodesToMonitor}
      triggerMonitoringUrl={triggerMonitoringUrl}
    >
      <Alert />
      <MonitorView />
      <Footer />
    </MonitoringContextController>
  );
}

function Alert() {
  const {
    dispatch,
    actions,
    state: { message },
  } = useMonitoringContext();
  const { content, error, warning, title } = message || {};
  const isTemporary = !!warning;

  useTimeout(
    () => {
      dispatch({ type: actions.CLEAR_MESSAGE });
    },
    isTemporary ? MESSAGE_DURATION : null,
  );

  if (!content) {
    return null;
  }

  return (
    <Message
      error={error}
      warning={warning}
    >
      {title && <Message.Header>{title}</Message.Header>}
      {content}.{error && ' Please contact support for further assistance.'}
    </Message>
  );
}
